import { render, staticRenderFns } from "./modalLayout.vue?vue&type=template&id=0c3ce2dc&scoped=true&"
import script from "./modalLayout.vue?vue&type=script&lang=js&"
export * from "./modalLayout.vue?vue&type=script&lang=js&"
import style0 from "./modalLayout.vue?vue&type=style&index=0&id=0c3ce2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ce2dc",
  null
  
)

export default component.exports